import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Constants } from 'src/app/constants/constants';
import { MessageConstants } from 'src/app/constants/message-constants';
import { ApiService } from 'src/app/service/api.service';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { ToastService } from 'src/app/service/toast.service';
import { UtilService } from 'src/app/service/util.service';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-link-device-to-vehicle-modal',
  templateUrl: './link-device-to-vehicle-modal.component.html',
  styleUrls: ['./link-device-to-vehicle-modal.component.scss']
})
export class LinkDeviceToVehicleModalComponent implements OnChanges {

  @ViewChild('searchVehicleForm', { static: true }) public searchVehicleForm: NgForm;

  @Input() modalId: string;
  @Input() modalOpenButtonId: string;
  @Input() modalCloseButtonId: string;
  @Input() modalHeader: string;
  @Input() content: string;
  @Input() deviceData: any;

  @Output() linkToVehicleSuccessEmitter: EventEmitter<any> = new EventEmitter<any>();

  vehicleData: any;
  invalidVinMessage: any;
  searchInput;
  isShowSearchInput: boolean = true;
  isLicensePlateReadOnly: boolean = false;

  // @Input() vehicleData: any;

  // @Output() submitEmitter: EventEmitter<any> = new EventEmitter<any>();
  // @Output() cancelEmitter: EventEmitter<any> = new EventEmitter<any>();
  // @Output() searchClickedEmitter: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private apiService: ApiService,
    private toastService: ToastService,
    private utilService: UtilService,
    private authService: AuthenticationService
  ) { }

  ngOnChanges(changes: SimpleChanges) {

    /* if (this.invalidVinMessage)
      this.invalidVinMessage = this.utilService.replaceTextInStatement(this.invalidVinMessage, "<VIN#>", this.searchInput) */

    /* if (this.vehicleData)
      this.isShowSearchInput = false; */

    // this.initVehicleData(this.vehicleData);
    this.initVehicleData(this.vehicleData);
  }

  onSubmit(form: NgForm) {
    if (form.valid) {
      // this.submitEmitter.emit();

      this.addDeviceToVehicle(this.vehicleData.vin);
      /* if (this.deviceData.telematicsProvider == 'CONTINENTAL') {
        this.addDeviceToVehicle(this.vehicleData.vin);
      } else {
        this.addAccountVehicleDevice();
      } */
      // this.addAccountVehicleDevice();

      document.getElementById(this.modalCloseButtonId).click();
    }
  }

  onCancel() {
    this.reset();
    // this.cancelEmitter.emit();
    document.getElementById(this.modalCloseButtonId).click();
  }

  onSearch(form: NgForm) {
    if (form.valid) {
      // this.searchClickedEmitter.emit(this.searchInput);
      this.getVehicleDetail(this.searchInput);
    }
  }

  okClicked() {
    console.log("okClicked()");
    document.getElementById("submitFormId").click();
  }

  reset() {
    this.resetParams();
    this.resetForm();
  }

  resetParams() {
    this.initVehicleData(null);
    this.setIsLicensePlateReadOnly(this.vehicleData.licensePlate);
    this.invalidVinMessage = null;
    this.searchInput = null;
    this.isShowSearchInput = true;
  }

  resetForm() {
    this.searchVehicleForm.reset();
    this.searchVehicleForm.resetForm();
  }

  getVehicleDetail(vin) {
    this.utilService.showSpinner();
    this.invalidVinMessage = null;

    this.apiService.getVehicleDetails(vin).then((data) => {
      this.utilService.hideSpinner();
      console.log("Get vehicle detail from api : ", data);
      this.processVehicleDetails(data);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getVehicleDetail(vin);
        });
      } else if (error.status == Constants.HTTP_NOT_FOUND) {
        this.utilService.hideSpinner();
        this.invalidVinMessage = this.utilService.replaceTextInStatement(Constants.INVALID_VIN_MESSAGE, "<VIN#>", this.searchInput)
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  processVehicleDetails(data: any) {

    // this.vehicleData = data;
    this.initVehicleData(data);
    // this.vehicleData.licensePlate = 33;
    this.setIsLicensePlateReadOnly(this.vehicleData.licensePlate);

    if (this.vehicleData)
      this.isShowSearchInput = false;
  }

  setIsLicensePlateReadOnly(licensePlate) {
    this.isLicensePlateReadOnly = licensePlate ? true : false;
  }

  /* addAccountVehicleDevice() {
    var requestPayload = this.getVehicleDeviceProvisioningPayload();
    console.log("device request payload::", requestPayload);
    this.utilService.showSpinner();
    this.apiService.provision(requestPayload).then((data) => {
      this.utilService.hideSpinner();
      console.log("add vehicle device response ::", data);
      this.toastService.showSuccess(MessageConstants.DEVICE_ADDED);
      let dongleStatus = data.data.devices[0].dongleStatus; //get dongleStatus from response and pass below
      this.linkToVehicleSuccessEmitter.emit({ vin: data.data.vin, dongleStatus: dongleStatus });
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.addAccountVehicleDevice();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  } */

  addDeviceToVehicle(vin) {
    var requestPayload = this.getAddVehicleDevicePayload();

    console.log("add device request payload::", requestPayload);
    this.utilService.showSpinner();
    this.apiService.addDeviceToVehicle(requestPayload, vin).then((data) => {
      this.utilService.hideSpinner();
      console.log("add vehicle device response ::", data);
      let addDeviceToVehicleResponse = data;
      this.toastService.showSuccess(MessageConstants.DEVICE_ADDED);
      // let dongleStatus = addDeviceToVehicleResponse.dongleStatus;

      this.linkToVehicleSuccessEmitter.emit({ vin: vin, responseData: addDeviceToVehicleResponse });
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.addDeviceToVehicle(vin);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }
  /* addDeviceToVehicle(vin) {
    let responseData = {
      "type": "DONGLE_DEVICE",
      "id": "647f6ee507d14f30158b329d",
      "deviceStatus": "INACTIVE",
      "telematicsType": "AFTER_MARKET",
      "telematicsProvider": "CONTINENTAL",
      "accountId": "63469baa07d14f70e2d29e56",
      "deviceSerialNumber": "121212121212",
      "dongleStatus": "LINKED"
    };

    this.linkToVehicleSuccessEmitter.emit({
      vin: vin, responseData: responseData
    });
  } */

  /* getVehicleDeviceProvisioningPayload() {
    return {
      "type": "VEHICLE",
      "provisioningData": {
        "enterpriseId": this.authService.loggedInUser.enterpriseId,
        "accountId": !isNullOrUndefined(this.vehicleData.accountId) ? this.vehicleData.accountId : this.utilService.selectedRentalFleetAccount.id,
        "vin": this.vehicleData.vin,
        "make": this.vehicleData.make.toUpperCase(),
        "model": this.vehicleData.model.toUpperCase(),
        "year": this.vehicleData.year,
        "color": this.vehicleData.color,
        "status": this.vehicleData.status,
        // "licensePlate": this.vehicleData.licensePlate,
        "devices": [this.deviceData]
      }
    };
  } */

  initVehicleData(vehicle) {
    this.vehicleData = {
      accountId: vehicle && vehicle.accountId ? vehicle.accountId : null,
      vin: vehicle && vehicle.vin ? vehicle.vin : null,
      make: vehicle && vehicle.make ? vehicle.make : null,
      model: vehicle && vehicle.model ? vehicle.model : null,
      year: vehicle && vehicle.year ? vehicle.year : null,
      color: vehicle && vehicle.color ? vehicle.color : null,
      status: vehicle && vehicle.status ? vehicle.status : null,
      licensePlate: vehicle && vehicle.licensePlate ? vehicle.licensePlate : null,
    }
  }

  handleInputChange(value: string) {
    if (value === '') {
      this.invalidVinMessage = null;
    }
  }

  getAddVehicleDevicePayload() {
    return {

      /* "type": "DONGLE_DEVICE",
      "telematicsProvider": "CONTINENTAL",
      "telematicsType": "AFTER_MARKET",
      "deviceSerialNumber": "ACCMb789680e0768ec8e",
      "manufacturer": "CONTINENTAL" */
      "type": this.deviceData.type,
      "telematicsProvider": this.deviceData.telematicsProvider,
      "telematicsType": this.deviceData.telematicsType,
      "deviceSerialNumber": this.deviceData.deviceSerialNumber,
      "manufacturer": this.deviceData.telematicsProvider
    };
  }

}